import { render } from "./countDown.vue?vue&type=template&id=1b7ea74e"
import script from "./countDown.vue?vue&type=script&lang=js"
export * from "./countDown.vue?vue&type=script&lang=js"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__